// lib/unclassifiedCollection.js
import { supabase } from "../lib/supabaseClient.js";

export async function getOrCreateUnclassifiedCollection(clientId) {
  if (!clientId) throw new Error("Client ID requis");

  // 1. Vérifier si une collection "Oeuvres non classées" existe déjà
  const { data: existingCollections, error: fetchError } = await supabase
    .from("collections")
    .select("id")
    .eq("client_id", clientId)
    .eq("title", "Œuvres non classées")
    .maybeSingle();

  if (fetchError) {
    console.error("Erreur vérification collection existante:", fetchError);
    throw fetchError;
  }

  if (existingCollections) {
    // Collection déjà existante ➔ renvoyer son id
    return existingCollections.id;
  }

  // 2. Sinon, créer une nouvelle collection
  const { data: newCollection, error: createError } = await supabase
    .from("collections")
    .insert({
      title: "Œuvres non classées",
      description: "Collection créée automatiquement pour les œuvres non assignées.",
      image_url: "/images/collections/ACLASSER.png",
      client_id: clientId
    })
    .select()
    .single();

  if (createError) {
    console.error("Erreur création collection non classée:", createError);
    throw createError;
  }

  return newCollection.id;
}
